const m = require('minthril');
const { component } = require('../../component');
const { previewHostname } = require('../../../../shared/preview-slug');

function readinessChecks(site, stats) {
  const domains = site.domainProvisioning || [];
  const previewUrl = `https://${previewHostname(site)}`;
  const primaryDomain = domains[0];
  const hasActiveCertificates = domains.length > 0 &&
    domains.every(domain => domain.status === 'active');
  const hasEdgeIp = domains.length > 0 &&
    domains.every(domain => Boolean(domain.edgeIp));
  const hasProxyActivity = site.domainStatus === 'active' &&
    Boolean(site.lastProxyRequestAt);
  const hasHomepageCache = Boolean(stats?.homepageCached);

  return [
    {
      label: 'Certificate active',
      complete: hasActiveCertificates,
      detail: domains.length
        ? primaryDomain.failureDetails || primaryDomain.failureReason || 'Your connected domain certificate is active.'
        : 'Connect a production domain first.',
      action: domains.length ? 'refresh-certificate' : 'settings'
    },
    {
      label: 'Edge IP available',
      complete: hasEdgeIp,
      detail: hasEdgeIp ? 'The production edge address is available.' : 'Waiting for the production edge address.'
    },
    {
      label: 'Proxy has received a request',
      complete: hasProxyActivity,
      detail: hasProxyActivity ? 'Spache has received traffic for this site.' : 'Open the preview or connected domain once.',
      action: 'preview',
      actionUrl: previewUrl
    },
    {
      label: 'Homepage is cached',
      complete: hasHomepageCache,
      detail: hasHomepageCache ? 'The homepage has a cached render.' : 'Open the homepage to start its first render.',
      action: 'preview',
      actionUrl: previewUrl
    }
  ];
}

const CutoverReadiness = component((vnode, emit) => {
  let expanded = false;
  const refreshing = new Set();

  return {
    view: ({ attrs: { site, stats, onRefreshDomain } }) => {
    const checks = readinessChecks(site, stats);
    const ready = checks.every(check => check.complete);

    if (ready && !expanded) {
      return m('section.cutover-readiness.cutover-readiness--collapsed',
        m('button.cutover-readiness__collapsed-button', {
          type: 'button',
          onclick: () => {
            expanded = true;
            emit('redraw');
          }
        },
        m('span.cutover-readiness__collapsed-label', 'Production status'),
        m('strong', 'Ready'),
        m('span.cutover-readiness__expand', 'View details ↓')
        )
      );
    }

    return m('section.cutover-readiness.panel-section',
      m('div.cutover-readiness__heading',
        m('div',
          m('p.eyebrow', 'Production readiness'),
          m('h3', ready ? 'Ready to cut over' : 'Not ready to cut over')
        ),
        m('span.cutover-readiness__state', { class: ready ? 'is-ready' : 'is-pending' },
          ready ? 'Ready' : 'In progress')
      ),
      ready && m('button.cutover-readiness__collapse-button', {
        type: 'button',
        onclick: () => {
          expanded = false;
          emit('redraw');
        }
      }, 'Collapse details ↑'),
      m('ul.cutover-readiness__checks', checks.map(check => m('li', {
        class: check.complete ? 'is-complete' : 'is-pending'
      },
      m('span.cutover-readiness__icon', check.complete ? '✓' : '!'),
      m('span',
        m('strong', check.label),
        m('small', check.detail),
        !check.complete && check.action === 'preview' && m('a.cutover-readiness__action', {
          href: check.actionUrl,
          target: '_blank',
          rel: 'noreferrer'
        }, 'Open preview ↗'),
        !check.complete && check.action === 'settings' && m('a.cutover-readiness__action', {
          href: `/sites/${site.id}/settings`
        }, 'Open settings →'),
        !check.complete && check.action === 'refresh-certificate' && onRefreshDomain && primaryDomain(site) && m('button.cutover-readiness__action', {
          type: 'button',
          disabled: refreshing.has(primaryDomain(site).domain),
          onclick: async () => {
            const domain = primaryDomain(site).domain;
            refreshing.add(domain);
            emit('redraw');
            try {
              await onRefreshDomain?.(domain);
            } finally {
              refreshing.delete(domain);
              emit('redraw');
            }
          }
        }, refreshing.has(primaryDomain(site).domain) ? 'Refreshing…' : 'Refresh certificate')
      ))))
    );
  }
  };
});

function primaryDomain(site) {
  return (site.domainProvisioning || [])[0];
}

module.exports = { CutoverReadiness };
